import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as L}from"../../icon-registry.js";const e=L("china",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.5H0V4.5Z"
                fill="#D80027" />
            <path
                d="M10.6107 15.6908L10.1569 14.961L9.31947 15.1668L9.87619 14.5072L9.42239 13.7774L10.2224 14.1002L10.7744 13.4405L10.7136 14.3013L11.5136 14.6241L10.6762 14.83L10.6107 15.6908ZM13.5955 8.33643L13.123 9.0569L13.6657 9.7259L12.8376 9.50134L12.3651 10.2265L12.3183 9.36567L11.4902 9.14111L12.2949 8.83234L12.2481 7.97152L12.7908 8.64052L13.5955 8.33643ZM11.0505 5.68848L10.9569 6.54462L11.7429 6.90017L10.9008 7.07795L10.8072 7.93409L10.3768 7.18555L9.53935 7.36333L10.1148 6.72239L9.68438 5.97854L10.4703 6.32941L11.0505 5.68848ZM13.6984 12.0698L13.0013 12.5797L13.2727 13.3984L12.5756 12.8932L11.8785 13.4078L12.1405 12.5844L11.4434 12.0838L12.3043 12.0791L12.5663 11.2557L12.8376 12.0744L13.6984 12.0698ZM5.38029 6.66625L6.18964 9.16918H8.81888L6.69491 10.7084L7.50426 13.2113L5.38029 11.6674L3.25163 13.2113L4.06567 10.7084L1.93701 9.16918H4.57093L5.38029 6.66625Z"
                fill="#FFDA44" />
        </svg>
    `),i=t`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <mask
            id="mask0_4915_40030"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="25">
            <circle
                cx="12"
                cy="12.5"
                r="12"
                fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4915_40030)">
            <g clip-path="url(#clip0_4915_40030)">
                <path
                    d="M-5.96484 0.5H30.0352V24.5H-5.96484V0.5Z"
                    fill="#D80027" />
                <path
                    d="M9.95096 17.2857L9.27026 16.191L8.01411 16.4998L8.8492 15.5103L8.1685 14.4156L9.3685 14.8998L10.1966 13.9103L10.1053 15.2015L11.3053 15.6857L10.0492 15.9945L9.95096 17.2857ZM14.4282 6.25416L13.7194 7.33486L14.5334 8.33837L13.2913 8.00152L12.5825 9.08924L12.5124 7.79802L11.2703 7.46117L12.4773 6.99802L12.4071 5.70679L13.2211 6.7103L14.4282 6.25416ZM10.6106 2.28223L10.4703 3.56644L11.6492 4.09977L10.386 4.36644L10.2457 5.65065L9.60008 4.52784L8.34394 4.79451L9.2071 3.8331L8.56148 2.71731L9.74043 3.24363L10.6106 2.28223ZM14.5825 11.8542L13.5369 12.6191L13.9439 13.8471L12.8983 13.0892L11.8527 13.8612L12.2457 12.6261L11.2001 11.8752L12.4913 11.8682L12.8843 10.6331L13.2913 11.8612L14.5825 11.8542ZM2.10534 3.74889L3.31938 7.50328H7.26324L4.07727 9.81205L5.29131 13.5664L2.10534 11.2506L-1.08764 13.5664L0.133412 9.81205L-3.05957 7.50328H0.891307L2.10534 3.74889Z"
                    fill="#FFDA44" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4915_40030">
                <rect
                    width="36"
                    height="24"
                    fill="white"
                    transform="translate(-5.96484 0.5)" />
            </clipPath>
        </defs>
    </svg>
`,n=L("china_rounded",i),o=L("CNY",i);export{o as CNY,e as China,n as ChinaRounded};
